import { TracePrecedentsIcon } from "../../../icons/TracePrecedentsIcon";
import type { MenuConfig } from "../../types";
import { useTraceTracePrecedentsModal } from "../../../market-grid/context-menu/useGetMenuItemsTracePrecedents";
import { any, anyCell, anyColumn, column, featureDisabled, selection, none, cell } from "../../disabled-helpers";
import { tracePrecedents } from "../../../actions";

export { useTraceTracePrecedentsModal };

export const tracePrecedentsSection: MenuConfig[] = [
  {
    id: "trace-precedents",
    label: "Trace precedents",
    isNew: new Date("2027-03-31"),
    icon: <TracePrecedentsIcon />,
    disabled: any(
      none(selection.isSingleCell),
      selection.isMultiColumn,
      selection.isMultiRow,
      selection.isFullColumn,
      featureDisabled("tracePrecedents"),
      none(anyColumn(column.hasFormula)),
      anyCell(cell.isManualEntry),
    ),
    action: (ctx) => () => tracePrecedents(ctx),
  },
];
